// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZN6I8"};